export const CORK_CENTRE = { lng: -8.4756, lat: 51.8985 };
export const AREAS = ["City Centre", "Northside", "Southside", "West"];
export const SORTS = [
  { key: "newest", label: "Newest" },
  { key: "trending", label: "Trending" },
  { key: "liked", label: "Most liked" },
];
// Placeholder details until the real organisation is confirmed.
export const ORG = {
  name: "ReimagineCork CLG",
  address: "Unit 4, Marina Commercial Park, Centre Park Road, Cork, T12 X7Y8, Ireland",
  email: "hello@reimaginecork.ie",
};
